import type { FaireProductEntity } from "../../entity_types/product";

export const p_x4x27s8yun: FaireProductEntity = {
  token: "p_x4x27s8yun",
  type: "product",
  name: "LM-SK-1000 BUBBLE SKIRT - DARK PURPLE",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/b16c795fe3d6f4a5aea8122d62f79506bb9285a56437fd51bb77ab2eb0218b10.jpeg",
  galleryImageUrls: [],
  priceDollars: 17.5,
  description: "This dark purple bubble skirt from Girlie Girl Originals is a women’s skirt in dark purple offered by the Girlie Girl Originals brand. It reflects the brand’s bold and fun style with southern flair and is suitable for retailers and boutiques seeking distinctive, trend-savvy apparel. Please contact Girlie Girl Originals to receive a copy of our MAP (minimum advertised price) policy.",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:32.671Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
